import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CountryDetectionService_GetCountryPopupLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/country_detection/v1/service.grpc.lazy';

export const useGetCountryPopupRequest = () => {
  return useGrpcRequest(
    CountryDetectionService_GetCountryPopupLazy,
    {},
    {
      disabled: !process.browser,
    },
  );
};
